import React, { Component } from "react";

import {
  // CCollapse,
  CListGroup,
  CListGroupItem,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle
} from "@coreui/react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { logout } from "../../../actions/baseActions";
import { setObj } from "../../../actions/noteActions";
import URL from "../../../config/api";
import axios from "../../../config/axios";
import { log } from "../../../utils/log";
import AtividadeTurma from "../ResumoAtividade";

import "../../../pages/Activity/Activity/Do/style.css";

// import ProtectedRoute from "../../../../components/ProtectedRoute";
// import Chart1 from "../../../../components/Statistics/1statistics/index";
// import DataQ from "../../../../components/Statistics/dataQuestions/index";
// import Desempenho from "../../../../components/Statistics/desempenhoPorAssunto/index";
// import TabelaDesempenho from "../../../../components/Statistics/tabelaDesempenho/index";
// import ListaNotas from "../../../../components/Statistics/listaNotas";
// import AtividadeAluno from "../../../../components/Statistics/atividadeAluno";
// import ListaAtividadeTurma from "../../../../components/Statistics/listaAtividadeTurma";
// import AcertosPorQuestao from "../../../../components/Statistics/acertosPorQuestao";
// import AcertosPorAssunto from "../../../../components/Statistics/acertosPorAssunto";

class StatisticsActivityDo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // list: [],
      // loading: true,
      applications: [],
      menu: "Resumo da Atividade"
      // dropdownItems: false
    };
  }

  async componentDidMount() {
    const respApplications = await axios.get(
      `${URL.api}evaluation/application/report?allocation_id=${this.props.allocation_id}`,
      { headers: { Authorization: `Bearer ${this.props.user.token}` } }
    );

    const respExecutions = await axios.get(
      `${URL.api}activity/execution/report?allocation_id=${this.props.allocation_id}`,
      { headers: { Authorization: `Bearer ${this.props.user.token}` } }
    );

    this.setState(
      {
        applications: respApplications.data.data,
        executions: respExecutions.data.data
      },
      () => this.createLog()
    );
  }

  createLog() {
    log(
      "access",
      this.props.currentRoute,
      `Acessou as estatísticas da atividade ${
        this.state.executions?.activity?.name
      }${
        this.props.activity
          ? ` dentro da atividade com id ${this.props.activity}`
          : ""
      }`,
      this.state.executions?.activity?.id,
      this.props.user.token,
      this.props.activity || null,
      this.props.general.active_roles.school_id || null
    );
  }

  getMenus() {
    return [
      {
        name: "Resumo da Atividade",
        component: (
          <AtividadeTurma
            applications={this.state.applications}
            executions={this.state.executions}
          />
        )
      }
      // {
      //   name: "Resumo da Atividade",
      //   component: (
      //     <AtividadeTurma
      //       applications={this.state.applications}
      //       executions={this.state.executions}
      //     />
      //   ),
      // },
      // {
      //   name: "Lista Relatorio",
      //   component: (
      //     <ActivityItemStatistics allocation_id={this.props.allocation_id} />
      //   ),
      //   hideMenu: false,
      // },
    ];
  }

  render() {
    return (
      <CModal
        size="lg w-100 h-100 m-0 p-2 mw-100"
        style={{ width: "100%", height: "100%" }}
        show={this.props.show}
        onClose={() => this.props.onClose()}
        closeOnBackdrop={false}
      >
        <CModalHeader closeButton>
          <CModalTitle>
            Estatísticas da atividade - {this.state.executions?.activity?.name}
          </CModalTitle>
        </CModalHeader>
        <CModalBody className="p-0 d-flex" style={{ overflow: "auto" }}>
          <CListGroup
            style={{
              height: "100%",
              backgroundColor:
                "#f6f8f9" /* , borderRight:"1px solid rgba(0, 0, 21, 0.125)" */
            }}
          >
            {this.getMenus()
              .filter(menu => !menu.hideMenu)
              .map((menu, index) => (
                <React.Fragment key={index}>
                  <CListGroupItem
                    action
                    active={menu.name === this.state.menu}
                    style={{
                      border: "0",
                      borderRadius: "0",
                      minWidth: "250px"
                    }}
                    className="cursor"
                    onClick={() => this.setState({ menu: menu.name })}
                  >
                    {menu.name}
                  </CListGroupItem>
                </React.Fragment>
              ))}
            {/*
            <CListGroupItem
              action
              active={"Itens da atividade" === this.state.menu}
              style={{ border: "0", borderRadius: "0", minWidth: "250px" }}
              className="cursor"
              onClick={() =>
                this.setState((state) => ({
                  dropdownItems: !state.dropdownItems,
                }))
              }
            >
              <div className="d-flex align-items-center justify-content-between">
                Itens da atividade
                <i
                  className={
                    "font-weight-bold fa fa-" +
                    (this.state.dropdownItems ? "angle-up" : "angle-down")
                  }
                ></i>
              </div>
            </CListGroupItem>
            <CCollapse show={this.state.dropdownItems}>
              <CListGroupItem
                action
                active={"Lista Relatorio" === this.state.menu}
                style={{
                  border: "0",
                  borderRadius: "0",
                  minWidth: "250px",
                  paddingLeft: "2.25rem",
                }}
                className="cursor"
                onClick={() => this.setState({ menu: "Lista Relatorio" })}
              >
                Lista Relatorio
              </CListGroupItem>
            </CCollapse>
            */}
          </CListGroup>
          <div
            className="p-3 charts flex-1 d-flex flex-column align-items-center"
            style={{ overflow: "auto" }}
          >
            <span className="est-text mb-3">
              <h1>{this.state.menu}</h1>
            </span>
            {
              this.getMenus().find(menu => menu.name === this.state.menu)
                .component
            }
          </div>
        </CModalBody>
      </CModal>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StatisticsActivityDo);
